const getTransitionStyles = (timeout, delay, delayExiting) => {
  const slowThenFast = "cubic-bezier(0.925, 0.035, 0.740, 1.010)"
  const fastThenSlow = "cubic-bezier(0.115, 0.815, 0.285, 0.865)"
  return {
    menuStyle: {
      entering: {
        opacity: 0,
        transform: `translateY(50px)`,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 1,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
        opacity: 0,
        transform: `translateY(-50px)`,
        transition: `all 200ms ease-in-out`,
      },
      exited:{
        opacity: 0,
      },
    },
    homeOverlay: {
      entering: {
        opacity: 0,
        transform: `translateY(5px)`,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 1,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {},
      exited: {}
    },
    opacityIn: {
      entering: {
        opacity: 0,
      },
      entered: {
        transition: `opacity ${timeout}ms ${delay}ms ease-in-out`,
        opacity: 1,
      },
      exiting: {},
    },
    opacityOut: {
      entering: {
      },
      entered: {
        opacity: 1,
      },
      exiting: {
        opacity: 0,
        transition: `opacity ${timeout}ms ${delay}ms ease-in-out`,
      },
    },
    upSlideStyle: {
      entering: {
        opacity: 0,
        transform: `translateX(10%)`,
      },
      entered: {
        opacity: 1,
        transform: `translate(0px)`,
        transition: `opacity ${timeout}ms ${delay}ms ease-in,
          transform ${timeout}ms ${delay}ms ${fastThenSlow}`,
      },
      exiting: {
        transform: `translateY(-100vh)`,
        transition: `all 200ms ${delayExiting}ms ease-in`,
      },
      exited: {
        opacity: 0,
      },
    },
    downSlideStyle: {
      entering: {
        opacity: 0,
        transform: `translateX(10%)`,
      },
      entered: {
        opacity: 1,
        transform: `translate(0px)`,
        transition: `opacity ${timeout}ms ${delay}ms ease-in,
          transform ${timeout}ms ${delay}ms ${fastThenSlow}`,
      },
      exiting: {
        transform: `translateY(+100vh)`,
        transition: `all 200ms ${delayExiting}ms ease-in`,
      },
      exited: {},
    },
    overlaySlideStyle: {
      entering: {},
      entered: {
        opacity: 1,
        transform: `translate(0px)`,
      },
      exiting: {
        transform: `translateY(-100vh)`,
        opacity: 0,
        transition: `all ${timeout}ms ${delayExiting}ms ${slowThenFast}`,
      },
      exited: {},
    },
    textAppearsNoExiting: {
      entering: {
        transform: `translateY(15px)`,
        opacity: 0,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 1,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
        opacity: 0,
      },
      exited: {},
    },
    textAppearsFromBottom: {
      entering: {
        transform: `translateY(15px)`,
        opacity: 0,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 1,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
        transform: `translateY(-10px)`,
        opacity: 0,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exited: {
        opacity: 0
      },
    },
    dotsAppearFromBottom: {
      entering: {
        transform: `translateY(5px)`,
        opacity: 0,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 0.8,
        transition: `transform ${timeout}ms ${delay}ms ease-in-out,
        opacity ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
        transform: `translateY(5px)`,
        opacity: 0,
        transition: `transform ${timeout}ms ${delay}ms ease-in-out,
        opacity ${timeout}ms ${delay}ms ease-in-out`,
      },
      exited: {},
    },
    lineTransitionLeft: {
      entering: {
        top: "49.7%",
        bottom: "50%",
        left: "50%",
      },
      entered: {
        top: '0',
        bottom: '0',
        left: '0',
        transition: `left ${timeout}ms ease-in-out,
          top ${timeout}ms ${delay}ms ease-in-out,
          bottom ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {},
      exited: {},
    },
    lineTransitionRight: {
      entering: {
        right: '50%',
        top: "49.7%",
        bottom: "50%",
      },
      entered: {
        right: '0',
        top: '0',
        bottom: '0',
        transition: `right ${timeout}ms ease-in-out,
          top ${timeout}ms ${delay}ms ease-in-out,
          bottom ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {},
      exited: {},
    },
    introLineTransitionLeft: {
      entering: {
        top: "79.7%",
        bottom: "20%",
        left: "50%",
        zIndex: "-1",
      },
      entered: {
        top: '0',
        bottom: '0',
        left: '0',
        zIndex: "2",
        transition: `left ${timeout}ms ${delay}ms ease-in-out,
          z-index 0ms ${delay + timeout}ms,
          top ${timeout - 600}ms ${delay + timeout}ms ${slowThenFast},
          bottom ${timeout - 600}ms ${delay + timeout}ms ${slowThenFast}`,
      },
      exiting: {},
      exited: {},
    },
    introLineTransitionRight: {
      entering: {
        top: "79.7%",
        bottom: "20%",
        right: '50%',
        zIndex: "-1",
      },
      entered: {
        right: '0',
        top: '0',
        bottom: '0',
        zIndex: "1",
        transition: `right ${timeout}ms ${delay}ms ease-in-out,
          z-index 0ms ${delay + timeout}ms,
          top ${timeout - 600}ms ${delay + timeout}ms ${slowThenFast},
          bottom ${timeout - 600}ms ${delay + timeout}ms ${slowThenFast}`
      },
      exiting: {},
      exited: {},
    },
    bgAppear: {
      entering: {
        top: "100%",
      },
      entered: {
        zIndex: "-1",
        top: "0",
        transition: `top ${timeout}ms ${delay}ms ${slowThenFast},
          z-index 0ms ${delay + 3000}ms`,
        height: "100%"
      },
      exiting: {},
      exited: {},
    },
    overlayAppears: {
      entering: {
        top: "0",
      },
      entered: {
        top: "0",
        zIndex: "-1",
        transition: `top ${timeout}ms ${delay}ms ease-in-out,
          z-index 0ms ${delay + timeout}ms`,
        height: "100%"
      },
      exiting: {
        top: "0",
        zIndex: "-1",
        transition: `top ${timeout}ms ${delay}ms ease-in-out,
          z-index 0ms ${delay + timeout}ms`,
        height: "100%"
      },
      exited: {},
    },
    exitOverlayAppears: {
      exiting: {
        top: "0",
        transition: `top 500ms ease-in-out`,
      }
    },
    pageAppearsFromBottom: {
      entering: {
        opacity: 0,
        transform: `translateY(100%)`,
      },
      entered: {
        opacity: 1,
        transform: `translateY(0)`,
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
      },
      exited: {
      },
    },
    disappear: {
      entering: {
        position: "absolute",
        top: 0,
      },
      entered: {
        top: "-100vh",
        transition: `all ${timeout}ms ${delay}ms ease-in-out`,
      },
      exiting: {
      },
      exited: {
      },
    },
  }
}

const getTransitionStyle = (status, timeout, delay, type, delayExiting) =>
  getTransitionStyles(timeout, delay, delayExiting)[type][status]

export default getTransitionStyle



// WEBPACK FOOTER //
// ./src/utils/getTransitionStyle.js